import React, { useRef, useEffect, useState } from 'react';
import riskReducer from '../../../store/reducers/riskReducer';
import { connect } from "react-redux";
import { compose } from "redux";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  ResponsiveContainer,
  LabelList,
} from 'recharts';

const dummyData = [
  { action_status: 'Due to 30', count: 40 },
  { action_status: 'Overdue 0-30', count: 30 },
  { action_status: 'Overdue 30-60', count: 20 },
  { action_status: 'Overdue 60', count: 10 },
];

const formattedData = (data) => {
  const total = data.reduce((sum, item) => sum + item.count, 0);

  return data.map((item) => {
    let color;
    switch (item.action_status) {
      case 'Due to 30':
        color = '#05769D';
        break;
      case 'Overdue 30-60':
        color = '#F07167';
        break;
      case 'Overdue 0-30':
        color = '#FED4AE';
        break;
      case 'Overdue 60':
        color = '#FFA500';
        break;
      default:
        color = '#8884d8';
    }

    return {
      name: item.action_status,
      value: item.count,
      percentage: ((item.count / total) * 100).toFixed(1),
      color,
    };
  });
};

const ActionsMetric = ({ height = 250, data  }) => {

  const [actionList, setactionList] = useState([]); 
  const [processedData, setprocessedData] = useState([]); 
  const totalActions = data ? data.reduce((sum, item) => sum + item.count, 0) : 0;

  useEffect(() => {
        if (data) {
            setactionList(data)
            setprocessedData(formattedData(data))
        }
    }, [data]);

  const safeHeight = typeof height === 'string' ? 150 : Math.max(height, 100);
  const calculatedOuterRadius = Math.min(safeHeight / 3, 40);
  const calculatedInnerRadius = calculatedOuterRadius - 20;

  return (
    <div 
      className="w-full bg-white rounded-lg flex flex-col justify-center"
      style={{ 
        height: typeof height === 'string' ? height : `${safeHeight}px`,
        minHeight: '100px',
        maxHeight: '150px',
        padding: 'min(8px, 1.5vh) min(8px, 2vw)',
        position: 'relative'
      }}
    >
      <div 
        className="text-gray-800 mb-1 absolute top-0 left-0 z-20"
        style={{ 
          fontSize: 'min(14px, 3.5vw)',
          margin: 'min(8px, 1.5vh) 0 0 min(8px, 2vw)',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }}
      >
        {totalActions} actions
      </div>

      <div className="flex-1 flex items-center justify-center" style={{ minHeight: '60px' }}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={processedData}
              cx="50%"
              cy="50%"
              innerRadius={calculatedInnerRadius}
              outerRadius={calculatedOuterRadius}
              fill="#8884d8"
              dataKey="value"
              paddingAngle={2}
            >
              {processedData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
              <LabelList dataKey="name" position="outside" style={{ fontSize: 'min(10px, 2.5vw)' }} />
            </Pie>
            <Tooltip formatter={(value, name, props) => [`${value}`, name]} />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};


const mapStateToProps = (state) => {
  //console.log("Actions", state.dashboard.general_dashboard_data.overdue_actions)
    return {

        //token: state.auth.token,
        //departments: state.department.departments,
        //department_id: state.department.department_id
        data:  state.dashboard.general_dashboard_data.overdue_actions
    };
};

const mapDispatchToProps = (dispatch) => {
    return {

    };
};
export default compose(connect(mapStateToProps, mapDispatchToProps))(ActionsMetric);
